// 店舗一覧 — 都道府県別件数（店舗一覧ページのみ）/ GPS・キーワード検索（TOP 共通）

const detailUrl = '/pages/shoplist-detail';

const SHOP_DATA_URL = window.shopListConfig?.apiUrl;

const SHOP_DATA_CACHE_KEY = 'shopListStores';
const SHOP_DATA_CACHE_TIME_KEY = 'shopListStoresCachedAt';
const SHOP_DATA_CACHE_LIMIT = 1000 * 60 * 10;
const SHOP_DATA_RETRY_DELAY = 1000;

//ローディング
const shoplistLoading = document.getElementById('shoplistLoading');

/**
 * GASから店舗データを取得
 */
function requestShopData() {
  return fetch(SHOP_DATA_URL).then((response) => {
    if (!response.ok) {
      throw new Error(`店舗データ取得エラー: ${response.status}`);
    }

    return response.json();
  });
}

/**
 * 店舗データを取得
 * - sessionStorageに有効なキャッシュがあれば使用
 * - キャッシュがなければGASから取得
 * - 取得失敗時は1秒後に1回だけリトライ
 */
function fetchShopData() {
  const cachedData = sessionStorage.getItem(SHOP_DATA_CACHE_KEY);
  const cachedAt = Number(sessionStorage.getItem(SHOP_DATA_CACHE_TIME_KEY));

  if (cachedData && cachedAt && Date.now() - cachedAt < SHOP_DATA_CACHE_LIMIT) {
    try {
      return Promise.resolve(JSON.parse(cachedData));
    } catch (error) {
      sessionStorage.removeItem(SHOP_DATA_CACHE_KEY);
      sessionStorage.removeItem(SHOP_DATA_CACHE_TIME_KEY);
    }
  }

  return requestShopData()
    .catch((error) => {
      console.warn('店舗データの取得に失敗しました。1秒後に再試行します。', error);

      return new Promise((resolve) => {
        window.setTimeout(resolve, SHOP_DATA_RETRY_DELAY);
      }).then(() => requestShopData());
    })
    .then((stores) => {
      sessionStorage.setItem(SHOP_DATA_CACHE_KEY, JSON.stringify(stores));
      sessionStorage.setItem(SHOP_DATA_CACHE_TIME_KEY, String(Date.now()));

      return stores;
    });
}

const shoplistTotal = document.getElementById('shoplistTotal');
const shoplistError = document.getElementById('shoplistError');
const shoplistReload = document.getElementById('shoplistReload');
const prefectureLinks = document.querySelectorAll('[data-prefecture]');

if (SHOP_DATA_URL && (shoplistTotal || prefectureLinks.length > 0)) {
  fetchShopData()
    .then((stores) => {
      if (shoplistLoading) {
        shoplistLoading.hidden = true;
      }
      if (shoplistTotal) {
        shoplistTotal.textContent = stores.length.toLocaleString('ja-JP');
      }

      prefectureLinks.forEach((link) => {
        const prefecture = link.dataset.prefecture;
        const count = stores.filter((store) => store.prefecture === prefecture).length;
        const countElement = link.querySelector('[data-prefecture-count]');

        if (countElement) {
          countElement.textContent = count;
        }
      });
    })
    .catch((error) => {
      console.error('店舗データを取得できませんでした。', error);

      if (shoplistLoading) {
        shoplistLoading.hidden = true;
      }

      if (shoplistTotal) {
        shoplistTotal.textContent = '-';
      }

      if (shoplistError) {
        shoplistError.hidden = false;
      }
    });
} else if (shoplistLoading) {
  shoplistLoading.hidden = true;
}

const shopSearchGps = document.getElementById('shopSearchGps');
const shopSearchKeywordBtn = document.getElementById('shopSearchKeywordBtn');
const shopSearchKeyword = document.getElementById('shopSearchKeyword');

shopSearchGps?.addEventListener('click', () => {
  location.href = `${detailUrl}?mode=gps`;
});

shopSearchKeywordBtn?.addEventListener('click', () => {
  const keyword = shopSearchKeyword?.value.trim();

  if (!keyword) return;

  location.href = `${detailUrl}?keyword=${encodeURIComponent(keyword)}`;
});

shopSearchKeyword?.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;

  const keyword = event.currentTarget.value.trim();

  if (!keyword) return;

  location.href = `${detailUrl}?keyword=${encodeURIComponent(keyword)}`;
});

shoplistReload?.addEventListener('click', () => {
  location.reload();
});
